import { Button } from '@mui/material';
import React from 'react';

const CustomButton = ({ children, fullWidth = false, isActive, ...rest }) => {
  return (
    <Button
      fullWidth={fullWidth}
      sx={(theme) => ({
        padding: '12px 24px',
        outline: isActive ? `1px solid ${theme.palette.secondary.main}` : '1px solid #DCE4E8',
        borderRadius: '14px',
        color: isActive ? '#fff' : 'rgb(0,0,0)',
        backgroundColor: isActive ? theme.palette.secondary.main : '#fff',
        '&:hover': {
          color: '#fff',
          backgroundColor: theme.palette.secondary.main + 'CC',
          outline: isActive ? `1px solid ${theme.palette.secondary.main + 'CC'}` : '1px solid #DCE4E8',
        },
      })}
      {...rest}
    >
      {children}
    </Button>
  );
};

export default CustomButton;
